import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-page-query',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet],
})
export class PageQueryComponent {}
